import { render, staticRenderFns } from "./UpdateCompany.vue?vue&type=template&id=1541a1ab&scoped=true"
import script from "./UpdateCompany.vue?vue&type=script&lang=js"
export * from "./UpdateCompany.vue?vue&type=script&lang=js"
import style0 from "./UpdateCompany.vue?vue&type=style&index=0&id=1541a1ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1541a1ab",
  null
  
)

export default component.exports